export default {
  nutritionTestsList: [],
  nutritionTestSelected: null,
  nutritionNegativeControl: null,
};
